(ns shared.core.reactive
  (:require
    [cljs-http.client :as http]
    [clojure.data :as data]
    [re-frame.core :as re-frame]
    [reagent.core :as reagent]
    [re-frame.interceptor :refer [->interceptor get-effect get-coeffect assoc-effect]]
    [re-frame.loggers :refer [console]]
    [re-graph.core :as re-graph]
    [reagent.dom :as rdom]
    [reagent.dom.server :as rdom.serv]
    [day8.re-frame.forward-events-fx]
    [shared.core.config :as config]
    [cljs.core.async :as async]
    [clojure.string :as s]
    [shared.core.util :as util]
    [venia.core :as venia]
    [shared.core.indexed-db :as indexed-db]
    [akiroz.re-frame.storage :refer [reg-co-fx!]]))

;; SHADOW EVENTS
(def shadow-loading?* (atom false))

(defn ^:dev/before-load before-load []
  (reset! shadow-loading?* true))

(defn ^:dev/after-load after-load []
  (reset! shadow-loading?* false))


;; AUTH0 STATE
(def auth0-root-path [:auth0])
(def auth0-details-path (conj auth0-root-path :details))

(def token-loading-ids* (atom #{}))

(defn auth0-details [db]
  (get-in db auth0-details-path))

;; REAGENT ALIASES
(def registered-handlers* (atom {}))
(def render rdom/render)
(def reactify-component reagent/reactify-component)
(def create-class reagent/create-class)
(def create-element reagent/create-element)
(def dom-node rdom/dom-node)
(def adapt-react-class reagent/adapt-react-class)
(def as-element reagent/as-element)
(def current-component reagent/current-component)
(def ratom reagent/atom)
(def props reagent/props)
(def children reagent/children)
(def render-to-string rdom.serv/render-to-string)
(def reg-cofx re-frame/reg-cofx)
(defn unmount-component-at-node [container]
  (rdom/unmount-component-at-node container))

(def create-root (when (exists? js/reagent.dom.client.create_root) js/reagent.dom.client.create_root))
(def render-root (when (exists? js/reagent.dom.client.render) js/reagent.dom.client.render))
(def unmount-root (when (exists? js/reagent.dom.client.unmount) js/reagent.dom.client.unmount))

;; RE-FRAME
(defn re-frame-dedupe-fn [re-frame-fn kind]
  (fn [& args]
    (when @config/debug?*
      (let [id (first args)
            kind-ids (get @registered-handlers* kind #{})]
        (when (and (not @shadow-loading?*) (contains? kind-ids id))
          (js/alert (str "ERROR: re-frame " (name kind) " " (first args) " is a duplicate")))
        (reset! registered-handlers* (assoc @registered-handlers* kind (conj kind-ids id)))))
    (apply re-frame-fn args)))
(def dispatch re-frame/dispatch)
(def dispatch-sync re-frame/dispatch-sync)
(def subscribe re-frame/subscribe)
(def reg-sub (re-frame-dedupe-fn re-frame/reg-sub :sub))
(def reg-event-db (re-frame-dedupe-fn re-frame/reg-event-db :event))
(def reg-event-fx (re-frame-dedupe-fn re-frame/reg-event-fx :event))
(def reg-fx re-frame/reg-fx)
(def clear-subscription-cache! re-frame/clear-subscription-cache!)


;; RE-GRAPH ALIASES
(def rg-init re-graph/init)
(def rg-query re-graph/query)
(def rg-mutate re-graph/mutate)


;; CONFIG ALIASES
(def endpoint-url config/endpoint-url)
(defn api-endpoint-url [path]
  (endpoint-url (str "/api" path)))


;; DISPATCHERS
(def ^:private dispatch-once-events* (atom #{}))
(def ^:private dispatch-hook-events* (atom {}))


;; INDEXED-DB
(def ^:private indexed-db-val-chans* (atom {}))
(def ^:private indexed-db-vals* (atom {}))
(def indexed-db-table-name "reactive")
(indexed-db/init {:db-name "novo"
                  :version 1
                  :clear-data? true
                  :table {:table-name indexed-db-table-name
                          :key-path "key"
                          :auto-increment? false
                          :indexes [{:kind "value" :unique? false}]}})

(def dispatch-once-interceptor
  (->interceptor
    :id :dispatch-once
    :after (fn [context]
             (let [{:keys [event]} (:coeffects context)]
               (swap! dispatch-once-events* disj event))
             context)))

(def dispatch-hook-interceptor
  (->interceptor
    :id :dispatch-hook
    :after (fn [context]
             (let [{:keys [event]} (:coeffects context)
                   event-key (first event)]
               (when-let [cur-hooks (@dispatch-hook-events* event-key)]
                 (doall
                   (for [h cur-hooks]
                     (dispatch h)))
                 (swap! dispatch-hook-events* dissoc event-key)))
             context)))

(defn dispatch-once [event-v]
  (when-not (@dispatch-once-events* event-v)
    (swap! dispatch-once-events* conj event-v)
    (dispatch event-v)))

(defn add-dispatch-hook [event-key hook-event-v]
  (let [cur-hooks (or (@dispatch-hook-events* event-key) #{})]
    (swap! dispatch-hook-events* assoc event-key (conj cur-hooks hook-event-v))))

(defn dispatch-load [event-v]
  (dispatch-once event-v)
  :loading)


;; EVENT MIDDLEWARE
(def debug-interceptor
  (->interceptor
    :id :debug
    :after (fn debug-after [context]
             (when @config/debug?*
               (let [event (get-coeffect context :event)
                     orig-db (get-coeffect context :db)
                     new-db (get-effect context :db ::not-found)]
                 (if (= new-db ::not-found)
                   (do
                     (console :group "Event: " event)
                     (console :groupEnd))
                   (let [[only-before only-after] (data/diff orig-db new-db)
                         db-changed? (or (some? only-before) (some? only-after))]
                     (console :group "Event: " event)
                     (when db-changed?
                       (console :log "Before: " only-before)
                       (console :log "After : " only-after))
                     (console :groupEnd)))))
             context)))

(def store-local-storage-in-db
  (->interceptor
    :id :storage-local-storage-in-db
    :after (fn debug-after [context]
             (let [new-db (or (get-effect context :db)
                              (get-coeffect context :db))
                   ls (or (get-effect context :local-storage)
                          (get-coeffect context :local-storage))]
               (assoc-effect context :db (assoc new-db :local-storage ls))))))

(def middleware [debug-interceptor
                 dispatch-hook-interceptor
                 dispatch-once-interceptor
                 re-frame/trim-v
                 (re-frame/inject-cofx :local-storage)
                 store-local-storage-in-db])

(def quiet-middleware
  [dispatch-once-interceptor
   re-frame/trim-v])

(defn unauthorized-errors-status? [errors]
  (some #(= (-> % :extensions :status) 401) errors))

(defn kick-out-if-unauthorized [{:keys [errors status]}]
  (when (or (unauthorized-errors-status? errors) (= status 401))
    (dispatch [:auth0/logout])))


;; RE-GRAPH HELPERS
(defn re-graph-init [bearer-token]
  (dispatch-sync [::re-graph/init
                  {:http-url (config/graphql-url)
                   :http-parameters (cond-> {:with-credentials? true}
                                            bearer-token (assoc :headers {"Authorization"
                                                                          (str "Bearer " bearer-token)}))
                   :ws-url false}]))

(defn every-error-is-status? [errors status]
  (every? (fn [{:keys [extensions]}] (= (:status extensions) status))
          errors))

(defn assoc-in-db-and-ls [{:keys [db local-storage]} path value]
  {:db (assoc-in db path value)
   :local-storage (assoc-in local-storage path value)})

(defn update-in-db-and-ls [{:keys [db local-storage]} path func value]
  {:db (update-in db path func value)
   :local-storage (update-in local-storage path func value)})

(defn apply-to-db-and-ls
  ([func {:keys [db local-storage]} args]
   {:db (apply func db args)
    :local-storage (apply func local-storage args)})
  ([func {:keys [db local-storage]} y args]
   {:db (apply func db y args)
    :local-storage (apply func local-storage y args)})
  ([func {:keys [db local-storage]} y z args]
   {:db (apply func db y z args)
    :local-storage (apply func local-storage y z args)}))

(def ^:private event-stats* (atom {}))

(defn initialize-event-stats [event-key {:keys [retry-count]}]
  (swap! event-stats* assoc event-key {:retry-count retry-count
                                       :attempts 0}))

(defn event-stats? [event-key]
  (not-empty (get @event-stats* event-key)))

(defn reset-event-stats-attempts [event-key]
  (when (event-stats? event-key)
    (swap! event-stats* assoc-in [event-key :attempts] 0)))

(defn inc-event-stats-attempts [event-key]
  (when (event-stats? event-key)
    (swap! event-stats* update-in [event-key :attempts] inc)))

(defn can-retry-event? [event]
  (when (event-stats? (first event))
    (let [{:keys [attempts retry-count]} (get @event-stats* (first event))]
      (and (pos? retry-count) (<= (or attempts 0) retry-count)))))

(defn retry-event-when-can [event]
  (when (can-retry-event? event)
    (inc-event-stats-attempts (first event))
    (dispatch event)))

(defn reg-rg-query-loader
  "
  Params:
  id            - loader event identifier
  path          - either a static vector db path or a function that receives the args passed to the loader dispatch call
                  that should return a vector db path
  gql-query     - either a graphql query string, a venia `graphql-query` map, or a function that receives the db and the
                  args passed to the loader dispatch call that should return a graphql query
  gql-args      - either a map of graphql args or a function that receives the db and the args passed to the
                  loader dispatch call that should return a map of graphql args

  Optional Params
  transf         - function that gets called to transform data (without errors) that's stored in `path` in db
  error-transf   - function that gets called to transform response that's stored in `path` in db when there are errors
  on-success     - function that gets called to transform response that's stored in `path` in db when there is a success
  kickout?       - set to `true` to kick the user out when there is a failure and it's due to a lack of authorization
  quiet-resp?    - set to `true` to use the `quiet-middleware` for the defined response event
  quiet-fail?    - set to `true` to avoid a failure toast if using the default `on-fail` function
  local-storage? - set to `true` to store data in the same path in local storage (can be used with
                   `reg-load-db-or-ls-sub`)
  "
  [id path gql-query gql-args & {:keys [transf error-transf on-success on-fail kickout? quiet-resp? quiet-fail?
                                        local-storage? indexed-db? store-empty-result? retry-count store-results?
                                        skip-unauthorized-check? block-until-complete?]
                                 :or {kickout? true
                                      store-results? (fn [_ _ _] true)
                                      on-success (fn [world-or-db _] world-or-db)}}]
  (let [on-fail (or on-fail
                    (fn [world-or-db {:keys [errors]} _ venia-query]
                      (when kickout?
                        (kick-out-if-unauthorized {:errors errors}))
                      (when-not quiet-fail?
                        (dispatch [:toasts/add-error
                                   {:errors errors
                                    :action (when venia-query
                                              {:text "Copy Error Info"
                                               :on-click #(dispatch-sync [:core/copy-to-clipboard
                                                                          (str "ERRORS: " (pr-str errors)
                                                                               "\n\n"
                                                                               "QUERY: query " venia-query)
                                                                          {:notify? true}])})}]))
                      world-or-db))
        resp-id (keyword (str (subs (str id) 1) "-resp"))
        path-fn (if (vector? path) (fn [_] path) path)
        gql-query-fn (if (or (string? gql-query) (map? gql-query))
                       (fn [_] gql-query)
                       gql-query)
        gql-args-fn (if (map? gql-args) (fn [_] gql-args) gql-args)
        complete?* (atom true)]
    (when (pos? retry-count)
      (initialize-event-stats id {:retry-count retry-count}))
    (reg-event-fx
      id middleware
      (fn [{:keys [db local-storage] :as world} args]
        (if (or @complete?* (not block-until-complete?))
          (let [path (when path-fn (apply path-fn (conj args (if local-storage? world db))))
                gql-query (apply gql-query-fn (if local-storage? world db) args)
                gql-args (apply gql-args-fn (if local-storage? world db) args)
                venia-query (if (map? gql-query)
                              (venia/graphql-query gql-query)
                              gql-query)]
            (reset! complete?* false)
            (inc-event-stats-attempts id)
            (if venia-query
              (let [reload? (= (last args) :reload)]
                (dispatch [:reactive/update-graphql-url "query" venia-query])
                (rg-query venia-query
                          gql-args
                          #(dispatch [resp-id % path args venia-query]))
                (when reload? (dispatch [:reactive/add-reloading-id id]))
                (if (or reload? (not path))
                  {:db db}
                  (if local-storage?
                    (let [ls-v (get-in local-storage path)]
                      (if (nil? ls-v)
                        (assoc-in-db-and-ls world path :loading)
                        {:db (assoc-in db path :loading)}))
                    {:db (assoc-in db path :loading)})))
              {:db db}))
          {:db db})))
    (reg-event-fx
      resp-id (if quiet-resp? quiet-middleware middleware)
      (fn [{:keys [db local-storage] :as world} [{:keys [errors] :as resp} path args venia-query]]
        (let [original-event [id (first args)]
              reload? (= (last args) :reload)]
          (when reload? (dispatch [:reactive/remove-reloading-id id]))
          (reset! complete?* true)
          (if errors
            (if (can-retry-event? original-event)
              (do
                (retry-event-when-can original-event)
                (if local-storage? {:db db :local-storage local-storage} {:db db}))
              (let [fail-world (if local-storage?
                                 (apply-to-db-and-ls on-fail world (select-keys resp [:errors]) args [venia-query])
                                 {:db (apply on-fail db (select-keys resp [:errors]) args [venia-query])})]
                (cond
                  (and (unauthorized-errors-status? errors) (not skip-unauthorized-check?))
                  (if path
                    (if local-storage?
                      (assoc-in-db-and-ls fail-world path nil)
                      {:db (assoc-in (:db fail-world) path nil)})
                    fail-world)

                  (or reload? (not path))
                  fail-world

                  :else
                  (let [v (cond-> (select-keys resp [:errors])
                                  error-transf (error-transf))]
                    (if local-storage?
                      (assoc-in-db-and-ls fail-world path v)
                      {:db (assoc-in (:db fail-world) path v)})))))
            (let [success-world (if local-storage?
                                  (apply-to-db-and-ls on-success world resp args)
                                  {:db (apply on-success db resp args)})
                  store-results? (apply store-results? db resp args)]
              (reset-event-stats-attempts id)
              (if (and path store-results?)
                (let [v (cond-> (:data resp)
                                transf (transf))]
                  (when indexed-db?
                    (indexed-db/add-object-store (indexed-db/db-indexed-db db)
                                                 {:table-name indexed-db-table-name
                                                  :values [{"key" path "value" v}]})
                    (swap! indexed-db-val-chans* dissoc path))
                  (cond
                    store-empty-result? {:db (assoc-in (:db success-world) path [])}
                    local-storage? (assoc-in-db-and-ls success-world path v)
                    :else {:db (assoc-in (:db success-world) path v)}))
                success-world))))))))

(defn cleanse-gql-query-string [in-string]
  ;; Continue to add necessary, cross-app string cleansing here
  ;; Note that if we add quote escaping here, we need to remove all of the places in all apps where it's being done
  ;; in the one-off query itself
  (-> in-string
      (s/replace #"\n" " ")))

(defn cleanse-gql-query-parts [parts]
  (cond
    (vector? parts) (mapv cleanse-gql-query-parts parts)
    (map? parts) (->> parts
                      (map (fn [[k v]]
                             [k (cond
                                  (string? v) (cleanse-gql-query-string v)
                                  :else v)]))
                      (into {}))
    :else parts))

(defn cleanse-gql-query [gql-query]
  (let [v-queries (:venia/queries gql-query)]
    (if v-queries
      (assoc gql-query :venia/queries (cleanse-gql-query-parts v-queries))
      gql-query)))

(defn reg-rg-mutation
  "
  Params:
  id            - mutation event identifier
  path          - either a static vector db path or a function that receives the args passed to the dispatch call that
                  should return a vector db path
  gql-query     - either a graphql query string, a venia `graphql-query` map, or a function that receives the db that
                  should return a graphql query
  gql-args      - either a map of graphql args or a function that receives the db that should return a map of graphql
                  args

  Optional Params
  on-success    - function that gets called on success responsible for providing updated db
  on-fail       - function that gets called on fail responsible for providing updated db
  db-update     - function that receives the db and the status of mutating? responsible for updating the db
  "
  [id path gql-query gql-args & {:keys [on-success on-fail db-update block-until-complete?]
                                 :or {on-success (fn [db _] db)
                                      on-fail (fn [db {:keys [errors]} _ venia-query]
                                                (kick-out-if-unauthorized {:errors errors})
                                                (dispatch [:toasts/add-error
                                                           {:errors errors
                                                            :action (when venia-query
                                                                      {:text "Copy Error Info"
                                                                       :on-click #(dispatch-sync [:core/copy-to-clipboard
                                                                                                  (str "ERRORS: " (pr-str errors)
                                                                                                       "\n\n"
                                                                                                       "QUERY: mutation " venia-query)
                                                                                                  {:notify? true}])})}])
                                                db)}}]
  (let [complete?* (atom true)
        resp-id (keyword (str (subs (str id) 1) "-resp"))
        path-fn (if (vector? path) (fn [_] path) path)
        gql-query-fn (if (or (string? gql-query) (map? gql-query))
                       (fn [_] gql-query)
                       gql-query)
        gql-args-fn (if (map? gql-args) (fn [_] gql-args) gql-args)]
    (reg-event-db
      id middleware
      (fn [db args]
        (if (or @complete?* (not block-until-complete?))
          (let [path (when path-fn (apply path-fn db args))
                db (if path (update-in db path dissoc :mutating?) db)
                gql-query (some-> (apply gql-query-fn db args) (cleanse-gql-query))
                gql-args (apply gql-args-fn db args)
                venia-query (if (map? gql-query)
                              (venia/graphql-query gql-query)
                              gql-query)]
            (reset! complete?* false)
            (if venia-query
              (do
                (dispatch [:reactive/update-graphql-url "mutate" venia-query])
                (rg-mutate venia-query
                           gql-args
                           #(dispatch [resp-id % args path venia-query]))
                (cond
                  db-update
                  (apply db-update db args [{:mutating? true}])

                  path
                  (assoc-in db (conj path :mutating?) true)

                  :else
                  db))
              db))
          db)))
    (reg-event-db
      resp-id middleware
      (fn [db [{:keys [errors] :as resp} args path venia-query]]
        (let [mod-db (cond
                       db-update
                       (apply db-update
                              (if path
                                (update-in db path dissoc :mutating?)
                                db)
                              args
                              [{:mutating? false}])

                       path
                       (update-in db path dissoc :mutating?)

                       :else
                       db)]
          (reset! complete?* true)
          (if errors
            (apply on-fail mod-db (select-keys resp [:errors]) args [venia-query])
            (apply on-success mod-db resp args)))))))

(defn reg-loader
  "
  Params:
  id   - loader event identifier
  path - either a static vector db path or a function that receives the args passed to the loader dispatch call
                  that should return a vector db path
  chan> - either a direct channel, or a function that receives the db that should return a channel

  Optional Params
  transf        - function that gets called to transform data (without errors) that's stored in `path` in db
  error-transf  - function that gets called to transform response that's stored in `path` in db when there are errors
  quiet-fail?   - set to `true` to avoid a failure toast if using the default `on-fail` function
  "
  [id path chan> & {:keys [transf error-transf on-success on-fail kickout? skip-response-on-req-id-mismatch?
                           handle-csrf-refresh? quiet-fail?]
                    :or {transf :body
                         error-transf :body
                         kickout? true
                         skip-response-on-req-id-mismatch? true
                         on-success (fn [db _] db)}}]
  (let [req-id-path [:reg-loader :request-ids id]
        on-fail (or on-fail
                    (fn [db {:keys [error-text body status]} _]
                      (let [errors [(cond
                                      (>= status 400)
                                      {:message (or body "Error Occurred")}

                                      (not-empty body)
                                      body

                                      :else
                                      {:message error-text})]]
                        (when kickout?
                          (kick-out-if-unauthorized {:errors errors
                                                     :status status}))
                        (when (and (not quiet-fail?)
                                   (some #(not (s/blank? (:message %))) errors))
                          (dispatch [:toasts/add-error {:errors errors}]))
                        db)))
        resp-id (keyword (str (subs (str id) 1) "-resp"))
        path-fn (if (vector? path) (fn [_] path) path)
        chan-fn (if (fn? chan>)
                  chan>
                  (fn [_] chan>))
        tried-csrf-refresh-ids* (atom #{})]
    (reg-event-db
      id middleware
      (fn [db args]
        (let [req-id (str (random-uuid))
              path (when path-fn (apply path-fn (conj (or args []) db)))
              csrf-refresh-id (conj (or path []) id)
              attempting-csrf-refresh? (contains? @tried-csrf-refresh-ids* csrf-refresh-id)
              ;; If we're attempting a CSRF refresh, we want to trigger an actual reload without removing loading state
              ;; from the actual state. Instead, we override the `db` that we received to make it look like it's not
              ;; actively loading.
              db (if (and attempting-csrf-refresh? (= (get-in db path) :loading))
                   (assoc-in db path nil)
                   db)
              chan> (apply chan-fn db args)]
          (if chan>
            ;; We're loading if the path says we're loading and it's not a csrf refresh attempt
            (let [loading? (= (get-in db path) :loading)]
              (when (not loading?)
                (async/take! chan> #(dispatch [resp-id % path args req-id])))
              (if (or loading? (= (last args) :reload) (not path))
                db
                (-> db
                    (assoc-in path :loading)
                    (assoc-in (conj req-id-path path) req-id))))
            db))))
    (reg-event-db
      resp-id middleware
      (fn [db [{:keys [status success] :as resp} path args req-id]]
        (let [active-req-id (get-in db (conj req-id-path path))
              reload? (= (last args) :reload)
              csrf-refresh-id (conj (or path []) id)]
          (if (and skip-response-on-req-id-mismatch? req-id active-req-id (not= active-req-id req-id) (not reload?))
            db
            (cond
              (= status 200)
              (let [success-db (apply on-success db resp args)]
                (swap! tried-csrf-refresh-ids* disj csrf-refresh-id)
                (if path
                  (assoc-in success-db path (cond-> resp
                                                    transf (transf db)))
                  success-db))

              (and handle-csrf-refresh? (not (contains? @tried-csrf-refresh-ids* csrf-refresh-id)) (= status 403))
              (do
                (swap! tried-csrf-refresh-ids* conj csrf-refresh-id)
                (async/take! (http/get "/csrf")
                             (fn [{:keys [status body]}]
                               (when (or (= 200 status) success)
                                 ;; This resets the CSRF token in the meta tag for the next request
                                 (some-> (js/document.getElementsByName "csrf")
                                         (aget 0)
                                         (.setAttribute "content" body)))
                               (dispatch (vec (concat [id] args)))))
                db)

              :else
              (let [fail-db (apply on-fail db resp args)]
                (swap! tried-csrf-refresh-ids* disj csrf-refresh-id)
                (cond
                  (unauthorized-errors-status? (-> resp :body :errors))
                  (if path
                    (assoc-in fail-db path nil)
                    fail-db)

                  (or reload? (not path))
                  fail-db

                  :else
                  (assoc-in fail-db path (cond-> resp
                                                 error-transf (error-transf))))))))))))

(defn reg-load-sub
  "
  id        - sub identifier
  path      - either a static vector db path or a function that receives the args passed to the loader dispatch call
              that should return a vector db path
  loader-id - loader event identifier
  "
  [id path loader-id]
  (let [path-fn (if (vector? path) (fn [_] path) path)]
    (reg-sub id
             (fn [db args]
               (let [path (apply path-fn (conj (or args []) db))
                     v (get-in db path)]
                 (if (nil? v)
                   (dispatch-load (conj [loader-id] args))
                   v))))))

(defn get-in-db-or-ls [db path]
  (let [ls-v (get-in (:local-storage db) path)
        db-v (get-in db path)]
    (if (and ls-v (not= ls-v :loading) (or (nil? db-v) (= db-v :loading)))
      ls-v
      db-v)))

(defn reg-load-db-or-ls-sub
  "
  id        - sub identifier
  path      - either a static vector db path or a function that receives the args passed to the loader dispatch call
              that should return a vector db path
  loader-id - loader event identifier
  "
  [id path loader-id]
  (let [path-fn (if (vector? path) (fn [_] path) path)]
    (reg-sub id
             (fn [db args]
               (let [path (apply path-fn (conj (or args []) db))
                     db-v (get-in db path)
                     v (get-in-db-or-ls db path)
                     load-vec (conj [loader-id] args)]
                 (if (nil? v)
                   (dispatch-load load-vec)
                   (do
                     (when (nil? db-v)
                       (dispatch-load load-vec))
                     v)))))))

(defn get-indexed-db-val [db path & {:keys [transf on-success]}]
  (when (indexed-db/indexed-db-key-version db path)
    (let [idb-v> (or (get @indexed-db-val-chans* path)
                     (let [chan (indexed-db/get-object-store-val-chan (indexed-db/db-indexed-db db)
                                                                      {:key-path path
                                                                       :table-name indexed-db-table-name
                                                                       :transf transf})]
                       (swap! indexed-db-val-chans* assoc path chan)
                       chan))
          v (some-> idb-v> (async/poll!))]
      (when v
        (swap! indexed-db-vals* assoc path v)
        (when on-success (on-success v)))
      (or (get @indexed-db-vals* path) v))))

(defn reg-load-indexed-db-sub
  "
  id        - sub identifier
  path      - either a static vector db path or a function that receives the args passed to the loader dispatch call
              that should return a vector db path
  loader-id - loader event identifier
  "
  [id path loader-id & {:keys [transf on-success]}]
  (let [path-fn (if (vector? path) (fn [_] path) path)]
    (reg-sub id
             (fn [db args]
               (let [path (apply path-fn (conj (or args []) db))
                     v (get-in db path)
                     idb-v (get-indexed-db-val db path :transf transf :on-success on-success)]
                 (indexed-db/indexed-db-key-version db path)
                 (if (nil? v)
                   (dispatch-load (conj [loader-id] args))
                   (or idb-v v)))))))

(defn reg-sub-full-else-slim
  [id slim-path full-path]
  (reg-sub
    id
    (fn [db]
      (let [full-data (get-in db full-path)]
        (if (and full-data (not= full-data :loading))
          full-data
          (get-in db slim-path))))))

(defn reg-load-sub-full-else-slim
  "
  id           - sub identifier
  loader-args  - map containing arguments for associated loaders
    :slim-loader-id     - slim loader event identifier
    :slim-loader-path   - either a static vector db path or a function that receives the args passed to the
                           slim loader dispatch call that should return a vector db path
    :full-loader-id     - full loader event identifier
    :full-loader-path   - either a static vector db path or a function that receives the args passed to the
                           full loader dispatch call that should return a vector db path
  "
  [id {:keys [slim-loader-id slim-path full-loader-id full-path]}]
  (let [path-fn (fn [path]
                  (if (vector? path) (fn [_] path) path))]
    (reg-sub
      id
      (fn [db args]
        (let [get-path (fn [path] (apply (path-fn path) (conj (or args []) db)))
              slim-data (get-in db (get-path slim-path))
              full-data (get-in db (get-path full-path))
              dispatch-fn (fn [loader-id args]
                            (when loader-id
                              (dispatch-load [loader-id args])))]
          (cond

            (and full-data (not= full-data :loading))
            full-data

            (and slim-data (not= slim-data :loading))
            (if (nil? full-data)
              (do
                (dispatch-fn full-loader-id args)
                slim-data)
              slim-data)

            (and (nil? full-data) (nil? slim-data))
            (do
              (dispatch-fn slim-loader-id args)
              (dispatch-fn full-loader-id args))

            (or (nil? full-data) (nil? slim-data))
            (do
              (when (nil? slim-data)
                (dispatch-fn slim-loader-id args))
              (when (nil? full-data)
                (dispatch-fn full-loader-id args)))

            :else :loading))))))

;; AUTH0 Wrappers
(defn auth0-event-id [id]
  (keyword (str (subs (str id) 1) "-auth0")))

(defn rg-event-id [id]
  (keyword (str (subs (str id) 1) "-rg")))

(defn reg-auth0-loader [id path request-config & additional-args]
  (let [event-id (rg-event-id id)
        path-fn (if (vector? path) (fn [_] path) path)
        loader-fn> (fn [db args]
                     (let [access-token (last args)
                           request-config (if (map? request-config)
                                            request-config
                                            (apply request-config db args))]
                       (when request-config
                         (http/request (assoc request-config :headers {"authorization" (str "Bearer " access-token)
                                                                       "x-csrf-token" (some-> (js/document.getElementsByName "csrf")
                                                                                              (aget 0)
                                                                                              (.getAttribute "content"))})))))
        additional-args-keys (some->> additional-args
                                      (take-nth 2)
                                      (into #{}))
        additional-args (if (some-> additional-args-keys (contains? :transf))
                          additional-args
                          (concat (or additional-args []) [:transf #(-> % :body (util/json-string->map))]))]
    (reg-event-db
      id middleware
      (fn [db args]
        (let [path (when path-fn (apply path-fn (conj [args] db)))
              loading? (= (get-in db path) :loading)
              reload? (= (last args) :reload)
              get-access-token-silently (:get-access-token-silently (auth0-details db))]
          (if (or (contains? @token-loading-ids* id) loading? (not path) (not get-access-token-silently))
            db
            (do
              (swap! token-loading-ids* conj id)
              (-> (get-access-token-silently)
                  (.then #(do
                            (dispatch-once (cond-> [event-id (conj args %)]
                                                   reload? (conj :reload)))
                            (dispatch [:auth0/clear-token-loading id])))
                  (.catch #(dispatch [:auth0/logout])))
              db)))))
    (apply reg-loader event-id path loader-fn> (concat additional-args [:handle-csrf-refresh? true]))))

(defn reg-auth0-load-sub [id path loader-id]
  (let [path-fn (if (vector? path) (fn [_] path) path)]
    (reg-sub id
             (fn [db args]
               (let [path (apply path-fn (conj (or args []) db))
                     v (get-in db path)]
                 (if (and (nil? v) (not (contains? @token-loading-ids* loader-id)))
                   (dispatch-load (conj [loader-id] args))
                   v))))))

(defn reg-auth0-rg-query-loader [id path gql-query gql-args & query-args]
  (let [event-id (rg-event-id id)
        path-fn (if (vector? path) (fn [_] path) path)
        gql-query-fn (if (or (string? gql-query) (map? gql-query))
                       (fn [_] gql-query)
                       gql-query)]
    (reg-event-db
      id middleware
      (fn [db ev-args]
        (let [path (when path-fn (apply path-fn (conj (or ev-args []) db)))
              gql-query (apply gql-query-fn db ev-args)
              loading? (= (get-in db path) :loading)
              get-access-token-silently (:get-access-token-silently (auth0-details db))
              venia-query (if (map? gql-query)
                            (venia/graphql-query gql-query)
                            gql-query)]
          (if (or (contains? @token-loading-ids* id) loading? (not get-access-token-silently) (not venia-query))
            db
            (let [reload? (= (last ev-args) :reload)]
              (swap! token-loading-ids* conj id)
              (-> (get-access-token-silently)
                  (.then #(do
                            (re-graph-init %)
                            (dispatch-once (-> [event-id] (concat ev-args) (vec)))
                            (dispatch [:auth0/clear-token-loading id])))
                  (.catch #(dispatch [:auth0/logout])))
              (if (and path (not reload?))
                (assoc-in db path :loading)
                db))))))
    (apply reg-rg-query-loader event-id path gql-query gql-args query-args)))

(defn reg-auth0-rg-mutation
  [id path gql-query gql-args & mutation-args]
  (let [event-id (rg-event-id id)
        path-fn (if (vector? path) (fn [_] path) path)
        gql-query-fn (if (or (string? gql-query) (map? gql-query))
                       (fn [_] gql-query)
                       gql-query)]
    (reg-event-db
      id middleware
      (fn [db ev-args]
        (let [path (when path-fn (apply path-fn (conj (or ev-args []) db)))
              gql-query (some-> (apply gql-query-fn db ev-args) (cleanse-gql-query))
              get-access-token-silently (:get-access-token-silently (auth0-details db))
              venia-query (if (map? gql-query)
                            (venia/graphql-query gql-query)
                            gql-query)]
          (if (or (contains? @token-loading-ids* id) (not get-access-token-silently) (not venia-query))
            db
            (do
              (swap! token-loading-ids* conj id)
              (-> (get-access-token-silently)
                  (.then #(do
                            (re-graph-init %)
                            (dispatch-once (-> [event-id] (concat ev-args) (vec)))
                            (dispatch [:auth0/clear-token-loading id])))
                  (.catch #(dispatch [:auth0/logout])))
              (if path
                (assoc-in db (conj path :mutating?) true)
                db))))))
    (apply reg-rg-mutation event-id path gql-query gql-args mutation-args)))

(defn auth0-http-request [id path build-req-options & {:keys [on-success on-fail]
                                                       :or {on-success (fn [db _ _] db)
                                                            on-fail (fn [db _ _] db)}}]
  (let [id-base (subs (str id) 1)
        req-id (keyword (str id-base "-req"))
        resp-id (keyword (str id-base "-resp"))
        path-fn (if (vector? path) (fn [_] path) path)]
    (reg-event-db
      id middleware
      (fn [db [args]]
        (let [path (when path-fn (apply path-fn (conj (if args [args] []) db)))
              request-active? (get-in db (conj path :request-active?))
              get-access-token-silently (:get-access-token-silently (auth0-details db))]
          (if request-active?
            db
            (do
              (-> (get-access-token-silently)
                  (.then #(dispatch [req-id {:event-args args
                                             :access-token %}]))
                  (.catch #(dispatch [:auth0/logout])))
              (assoc-in db (conj path :request-active?) true))))))
    (reg-event-db
      req-id middleware
      (fn [db [{:keys [event-args access-token attempt-csrf-refresh?] :as args}]]
        (let [{:keys [headers] :as req-options} (build-req-options db event-args)
              path (when path-fn (apply path-fn (conj (if event-args [event-args] []) db)))]
          (when (not-empty req-options)
            (async/take! (http/request
                           (merge {:method :post
                                   :headers (merge {"authorization" access-token
                                                    "x-csrf-token" (some-> (js/document.getElementsByName "csrf")
                                                                           (aget 0)
                                                                           (.getAttribute "content"))}
                                                   headers)}
                                  (dissoc req-options :headers)))
                         #(do
                            (dispatch [resp-id
                                       %
                                       (if (nil? attempt-csrf-refresh?)
                                         (assoc args :attempt-csrf-refresh? true)
                                         args)]))))
          (if (empty? req-options)
            (assoc-in db (conj path :request-active?) false)
            db))))
    (reg-event-db
      resp-id middleware
      (fn [db [{:keys [status success] :as resp} {:keys [event-args attempt-csrf-refresh?] :as args}]]
        (let [path (when path-fn (apply path-fn (conj (if event-args [event-args] []) db)))
              {:keys [response-type]} (build-req-options db event-args)
              resp (update resp :body #(cond
                                         (or (= response-type :blob)
                                             (= response-type :text))
                                         %

                                         (map? %) %

                                         :else
                                         (try
                                           (some-> % (util/json-string->map) (util/->kebab-case-keywords))
                                           (catch :default _
                                             %))))
              request-inactive-db (update-in db path dissoc :request-active?)]
          (cond
            (and (= status 403) attempt-csrf-refresh?)
            (do
              (async/take! (http/get "/csrf")
                           (fn [{:keys [status body]}]
                             (when (or (= 200 status) success)
                               ;; This resets the CSRF token in the meta tag for the next request
                               (some-> (js/document.getElementsByName "csrf")
                                       (aget 0)
                                       (.setAttribute "content" body)))
                             (dispatch [req-id (assoc args :attempt-csrf-refresh? false)])))
              db)

            success
            (on-success request-inactive-db [resp] args)

            :else
            (on-fail request-inactive-db resp args)))))))

(reg-event-db
  :reactive/clear-indexed-db-table middleware
  (fn [db]
    (reset! indexed-db-val-chans* {})
    (reset! indexed-db-vals* {})
    (indexed-db/clear-object-store (indexed-db/db-indexed-db db) indexed-db-table-name)
    db))

(reg-co-fx! :novo
            {:fx :local-storage
             :cofx :local-storage})

(reg-event-db
  :reactive/update-graphql-url quiet-middleware
  (fn [db [kind venia-query]]
    (assoc-in db [:re-graph :re-graph.internals/default :http-url] (str (config/graphql-url)
                                                                        "?"
                                                                        kind
                                                                        "="
                                                                        (some-> venia-query
                                                                                (s/split "{")
                                                                                (second)
                                                                                (s/split "(")
                                                                                (first))))))


;; RELOAD HELPERS
(reg-event-db
  :reactive/add-reloading-id quiet-middleware
  (fn [db [id]]
    (assoc db :reloading-ids (conj (or (:reloading-ids db) #{}) id))))

(reg-event-db
  :reactive/remove-reloading-id quiet-middleware
  (fn [db [id]]
    (update db :reloading-ids disj id)))

(reg-sub
  :reactive/reloading-ids-
  (fn [db]
    (:reloading-ids db)))

(reg-sub
  :reactive/id-reloading?-
  (fn [db [_ id]]
    (contains? (or (:reloading-ids db) #{}) id)))
